import React from 'react';
import MessageList from './MessageList';
import InputBar from './InputBar';
import VoiceOverlay from './VoiceOverlay';

export default function ConversationPanel({
  className = '',
  onCardRespond,
  onSendText,
  onUploadFile,
  onStartVoice,
  onStopVoice,
  voiceStatus,
  isSpeaking,
  isListening,
  hasUserSpoken,
}) {
  const isVoiceActive = voiceStatus === 'connected';

  return (
    <div className={`conversation-panel ${className}`.trim()}>
      {isVoiceActive && (
        <VoiceOverlay
          isSpeaking={isSpeaking}
          isListening={isListening}
          hasUserSpoken={hasUserSpoken}
          onStop={onStopVoice}
        />
      )}
      <MessageList onCardRespond={onCardRespond} />
      <InputBar
        onSendText={onSendText}
        onUploadFile={onUploadFile}
        onStartVoice={onStartVoice}
        onStopVoice={onStopVoice}
        voiceStatus={voiceStatus}
        isSpeaking={isSpeaking}
      />
    </div>
  );
}
